export class RegisterUser {
  email: String;
  password: String;
  name: String;
  cpforcnpj: number;
  phone: number;
  address: String;
  //country: String;
}
